if (!customElements.get('share-modal')) {
  class ShareModal extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.js-share-open');
      this.overlay = this.querySelector('.share-modal__overlay');
      this.dialog = this.querySelector('.share-modal__dialog');
      this.closeBtn = this.querySelector('.js-share-close');
      this.copyBtn = this.querySelector('.js-share-copy');
      this.copyStatus = this.querySelector('.share-modal__copy-status');

      // Move the overlay to <body> so its position: fixed and z-index aren't
      // trapped by the containing block/stacking context that #product-media
      // creates via `container-type: inline-size` (used for container queries
      // in media-gallery.css). Otherwise the overlay renders confined to that
      // column, appearing behind the header and product info.
      if (this.overlay && this.overlay.parentElement !== document.body) {
        document.body.appendChild(this.overlay);
      }

      this.keyupHandler = this.handleKeyup.bind(this);

      this.trigger.addEventListener('click', () => this.open());
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (evt) => {
        if (!this.dialog.contains(evt.target)) this.close();
      });
      if (this.copyBtn) {
        this.copyBtn.addEventListener('click', () => this.copyLink());
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keyup', this.keyupHandler);
    }

    open() {
      clearTimeout(this.hideTimeout);
      this.overlay.hidden = false;
      // Next frame, so the opacity transition runs
      requestAnimationFrame(() => this.overlay.classList.add('is-active'));
      document.body.style.overflow = 'hidden';
      document.addEventListener('keyup', this.keyupHandler);
      this.closeBtn.focus();
    }

    close() {
      this.overlay.classList.remove('is-active');
      // Keep the overlay in the DOM until the fade-out finishes
      this.hideTimeout = setTimeout(() => {
        this.overlay.hidden = true;
      }, 200);
      document.body.style.overflow = '';
      document.removeEventListener('keyup', this.keyupHandler);
      this.resetCopyState();
      this.trigger.focus();
    }

    handleKeyup(evt) {
      if (evt.key === 'Escape') this.close();
    }

    async copyLink() {
      const url = this.copyBtn.dataset.shareUrl;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          const input = document.createElement('textarea');
          input.value = url;
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        }

        this.copyBtn.classList.add('is-copied');
        if (this.copyStatus) this.copyStatus.textContent = 'Link copied';

        clearTimeout(this.copyTimeout);
        this.copyTimeout = setTimeout(() => this.resetCopyState(), 3000);
      } catch (e) {
        // Clipboard unavailable - leave the plain URL visible for manual copy
      }
    }

    resetCopyState() {
      clearTimeout(this.copyTimeout);
      if (this.copyBtn) this.copyBtn.classList.remove('is-copied');
      if (this.copyStatus) this.copyStatus.textContent = '';
    }
  }

  customElements.define('share-modal', ShareModal);
}
